import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { TaskStatus } from '../context/GlobalContext'
import useGlobalContext from './useGlobalContext'

type ReturnProps = {
    loaded: boolean
    taskStatuses: TaskStatus[]
    activeTaskStatusCodes: string[]
    getStartStatus: () => TaskStatus
    getStatus: (key: string) => TaskStatus
    getStatusName: (id: string) => string
}

function getPosition(taskStatus: TaskStatus): number {
    if (taskStatus.isStartStatus) {
        return taskStatus.position || 1000
    }
    if (taskStatus.isEndStatus) {
        return 10_000 + (taskStatus.position || 1000)
    }

    return taskStatus.position || 1000
}

export default function useTaskStatuses(): ReturnProps {
    const { i18n } = useTranslation()
    const { entities, loaded } = useGlobalContext('taskStatuses')

    const getStartStatus = () => taskStatuses.find(value => !!value.isStartStatus)

    const taskStatuses: TaskStatus[] = useMemo(() => entities?.sort((a, b) => getPosition(a) - getPosition(b)) || [], [entities])
    const activeTaskStatusCodes = useMemo(() => taskStatuses?.filter(status => !status.isEndStatus).map(task => task.alpha), [taskStatuses])
    const getStatus = (key: string) => taskStatuses.find(value => value.alpha === key)
    const getStatusName = (id: string) =>
        getI18NName(
            taskStatuses.find(value => value.alpha === id),
            i18n.language,
        )

    return { loaded, taskStatuses, activeTaskStatusCodes, getStartStatus, getStatus, getStatusName }
}
